module.exports = __webpack_public_path__ + "img/IRANYekan-Light.22849af.svg";